import { DataQualitySnapshot, DataQualityBreakdown } from '@/types/webSearch';

export interface OverallDataQuality {
  score: number;
  label: string;
  summary: string;
  breakdown: DataQualityBreakdown;
}

export interface KeyContactsStats {
  total: number;
  withEmail: number;
  withPhone: number;
}

export function computeOverallDataQuality(
  history: DataQualitySnapshot[],
  fallback?: DataQualitySnapshot | null,
  keyContactsStats?: KeyContactsStats
): OverallDataQuality {
  const snapshots = history.length > 0 ? history : fallback ? [fallback] : [];
  
  const best: DataQualityBreakdown = {
    contactInfo: 0,
    companyInfo: 0,
    onlinePresence: 0,
    servicesProducts: 0,
    teamLeadership: 0,
  };

  for (const snap of snapshots) {
    for (const key of Object.keys(best) as (keyof DataQualityBreakdown)[]) {
      best[key] = Math.max(best[key], snap.breakdown[key] || 0);
    }
  }

  // Apply live contacts floor adjustment
  if (keyContactsStats) {
    if (keyContactsStats.withEmail >= 3) {
      best.contactInfo = Math.max(best.contactInfo, 4);
    } else if (keyContactsStats.withEmail >= 1) {
      best.contactInfo = Math.max(best.contactInfo, 3);
    } else if (keyContactsStats.total > 0) {
      best.contactInfo = Math.max(best.contactInfo, 2);
    }
  }

  const total = best.contactInfo + best.companyInfo + best.onlinePresence + best.servicesProducts + best.teamLeadership;
  const score = Math.round((total / 25) * 100);
  const label = score >= 76 ? 'Excellent' : score >= 51 ? 'Good' : score >= 26 ? 'Fair' : 'Poor';

  const summary = `Overall quality based on best data across ${snapshots.length} enrichment stage${snapshots.length !== 1 ? 's' : ''}.`;

  return { score, label, summary, breakdown: best };
}
